import type { Directive } from "vue"
import { useTutorial } from "@/composables/useTutorial"

export const vTutorial: Directive = {
    mounted(el, binding) {
        const tutorial = useTutorial()

        tutorial.register(binding.value, el)
    },

    unmounted(el, binding) {
        const tutorial = useTutorial()

        tutorial.unregister(binding.value)
    }
}